<template>
    <div class="body-panel projects">
        <div class="body-panel-control separator" v-if="info.User && info.User.MainRole === 'administrators'">
            <div class="control-block-left">
                <div class="flex">
                    <p class="btn-back margin-right-10">
                        <a class="router-link-active" href="" @click.prevent="$router.back()">Назад</a>
                    </p>
                    <div class="form-field margin-right-20">
                        <drop-down class=""
                                   :items="accesses"
                                   :dataField="'Id'"
                                   :textField="'Name'"
                                   v-model="accessId"
                                   @change="onAccessChange($event)"></drop-down>
                    </div>
                </div>
            </div>
            <div class="control-block-right"></div>
        </div>
        <div class="body-panel-content body-panel-content-page" @scroll="onScroll">
            <table class="table-view" id="dataTable">
                <thead class="head-show">
                    <tr class="heading">
                        <th>Название проекта</th>
                        <th>URL адрес</th>
                        <th>Доступ к приложению</th>
                        <th>Ссылка в Google Play</th>
                        <th>Ссылка в App Store</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) of projectList">
                        <td class="id">{{item.Name}}</td>
                        <td class="link pointer" @click.stop="openSubdomain(item)">{{item.Subdomain}}</td>
                        <td class="date-range">{{ item.AppAccessTypeName }}</td>
                        <td :class="['link', {'pointer': item.UrlGooglePlay}]" @click.stop="openGooglePlay(item)">{{ item.UrlGooglePlay }}</td>
                        <td :class="['link', {'pointer': item.UrlAppStore}]" @click.stop="openAppStore(item)">{{ item.UrlAppStore }}</td>
                        <td class="value-center">
                            <button type="button" class="btn" @click.stop="openProjectEdit(item)" title="Редактировать">Редактировать</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <popup-window ref="ppAppAccessControlModal" :title="'Управление доступом к приложению'">
            <div class="form-field-group mob-inline">
                <div class="form-field">
                    <div>
                        <label class="input-text-lbl">Название проекта</label>
                        <input type="text" name="Name" class="input-text" v-model="selectedProject.Name" :disabled="true" />
                    </div>
                    <div class="margin-top-5">
                        <label class="input-text-lbl">URL адрес</label>
                        <input type="text" name="Subdomain" class="input-text" v-model="selectedProject.Subdomain" :disabled="true" />
                    </div>
                    <div class="margin-top-5">
                        <label class="input-text-lbl">Доступ к приложению</label>
                        <drop-down :items="[{ Id: 1, Name: 'Запрещено' }, { Id: 2, Name: 'FoxinBox' }, { Id: 3, Name: 'Отдельное приложение' }]"
                                   :dataField="'Id'"
                                   :textField="'Name'"
                                   v-model="selectedProject.AppAccessType"></drop-down>
                    </div>
                    <div>
                        <label class="input-text-lbl">Ссылка в Google Play</label>
                        <input maxlength="256" name="UrlGooglePlay" v-model="selectedProject.UrlGooglePlay" class="input-text" type="text">
                    </div>
                    <div>
                        <label class="input-text-lbl">Ссылка в App Store</label>
                        <input maxlength="256" name="UrlAppStore" v-model="selectedProject.UrlAppStore" class="input-text" type="text">
                    </div>
                </div>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="saveProject">Сохранить</button>
                <button type="button" class="btn" @click="closeModal('ppAppAccessControlModal')">Отмена</button>
            </div>
        </popup-window>

        <vue-headful title="Доступ к приложению" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import 'datatables.net'
    import BackendApi from '../backendApi'
    import UI from '../helpers/ui-helpers'
    import moment from 'moment'
    import projectMixin from '../helpers/project-mixin'
    import claimsCheckingMixin from '../helpers/claims-checking-mixin'
    import _ from 'lodash'

    let backendApi = new BackendApi();

    let AccessTypes = {
        /* Доступ к приложению */
        All: 0,
        /* Запрещено */
        Forbidden: 1,
        /* FoxinBox */
        FoxinBox: 2,
        /* Отдельное приложение */
        Single: 3
    };

    export default {
        name: "projects",

        data() {
            return {
                selectedProject: {Id:0,Name:null},
                projectList: [],
                accessId: AccessTypes.All,
                loading: false,
                canBeLoaded: true,
                page: 1,
                scrollTop: null,
                accesses: [
                    { Id: 0, Name: 'Доступ к приложению' }, { Id: 1, Name: 'Запрещено' }, { Id: 2, Name: 'FoxinBox' }, { Id: 3, Name: 'Отдельное приложение' },
                ],
            }
        },

         computed: {
         },

        mixins: [projectMixin, claimsCheckingMixin],

        methods: {
            onAccessChange() {
                this.reload();
            },

            reload() {
                this.page = 1;
                this.projectList = [];
                this.loading = false;
                this.canBeLoaded = true;

                this.loadNext();
            },

            loadNext(){
                let vm = this;
                if (!vm.info.User || vm.info.User.MainRole !== 'administrators') {
                    this.$router.back();
                    return;
                }

                this.loading = true;
                UI.blockUI('.projects', 'Загрузка...');
                this.callApiWrapper(backendApi.projectAppAccess((vm.page - 1) * 40, 40, vm.accessId)).then(function (resp) {
                    if(resp.hasError){
                        UI.toastr.error('Ошибка во время загрузки проектов');
                    }
                    else{
                        if (resp.data && resp.data.length) {
                            for (let p of resp.data) {
                                p.AppAccessTypeName = vm.AppAccessTypeName(p.AppAccessType);
                            }
                            vm.projectList.push(...resp.data);
                        }
                        else{
                            vm.canBeLoaded = false;
                        }
                    }
                    UI.unblockUI('.projects');
                    vm.loading = false;
                });
            },

            onScroll(e) {
                let vm = this;
                if (!vm.loading && vm.canBeLoaded) {
                    let elem = $(e.target);
                    vm.scrollTop = elem.scrollTop();
                    if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            },

            openProjectEdit(item) {
                let vm = this;
                vm.selectedProject.Id = item.Id;
                vm.selectedProject.Name = item.Name;
                vm.selectedProject.Subdomain = item.Subdomain;
                vm.selectedProject.AppAccessType = item.AppAccessType;
                vm.selectedProject.UrlGooglePlay = item.UrlGooglePlay;
                vm.selectedProject.UrlAppStore = item.UrlAppStore;
                this.onShowModal('ppAppAccessControlModal');
            },

            openSubdomain(item) {
                window.open('https://' + item.Subdomain);
            },

            openGooglePlay(item) {
                if (item.UrlGooglePlay)
                    window.open(item.UrlGooglePlay);
            },

            openAppStore(item) {
                if (item.UrlAppStore)
                    window.open(item.UrlAppStore);
            },

            saveProject() {
                let vm = this;
                let saveObj = Object.assign({}, vm.selectedProject);

                UI.blockUI('.projects', 'Удаление...');
                backendApi.projectAppAccessSave(saveObj).then(function (response) {
                    UI.unblockUI('.projects');
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при редактировании проекта');
                    } else {
                        UI.toastr.success('Успешно сохранено');

                        vm.closeModal('ppAppAccessControlModal');

                        let item = vm.projectList.find(x => x.Id === vm.selectedProject.Id);
                        item.AppAccessType = vm.selectedProject.AppAccessType;
                        item.UrlGooglePlay = vm.selectedProject.UrlGooglePlay;
                        item.UrlAppStore = vm.selectedProject.UrlAppStore;
                        item.AppAccessTypeName = vm.AppAccessTypeName(item.AppAccessType);
                    }
                });
            },

            AppAccessTypeName(appAccessType) {
                let typeName = "Запрещено";
                switch (appAccessType) {
                    case AccessTypes.FoxinBox:
                        typeName = "FoxinBox";
                        break
                    case AccessTypes.Single:
                        typeName = "Отдельное приложение";
                        break;
                }
                return typeName;
            }
        },

        mounted () {
            let vm = this;

            vm.$nextTick(() => {
                vm.loadNext();
            })
        },

        destroyed(){
            $('.body-panel-content').off('scroll');
        }
    }
</script>

<style scoped>
    .table-view tr{ cursor:default;}
    .table-view td.pointer{cursor: pointer;text-overflow: ellipsis;white-space: nowrap;}
</style>



// WEBPACK FOOTER //
// Content/src/views/ProjectsAppAccess.vue